<template>
  <div>
    <div>{{ label }}</div>
    <div class="datetime-input">
      <b-form-input :id="`${label}-date-input`" type="text" :value="dateTimeValue" readonly class="hide" />
      <b-form-input :id="`${label}-date-input`" v-model="dateValue" type="date" @blur="onInput" />
      <b-form-input :id="`${label}-time-input`" v-model="timeValue" type="time" @blur="onInput" />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns-tz";

export default {
  name: "DataEnabledDateTimeInput",

  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      dateValue: this.dateFormatter(new Date()),
      timeValue: this.timeFormatter(new Date()),
      isAddButtonEnabled: false,
    };
  },

  computed: {
    dateTimeValue() {
      const dateTime = this.dateTimeFormatter(`${this.dateValue}T${this.timeValue}`);

      this.isAddButtonEnabled ? this.$emit("input", dateTime) : this.$emit("input", "");

      return dateTime;
    },
  },

  methods: {
    dateFormatter(value) {
      return format(new Date(value), "yyyy-MM-dd");
    },

    timeFormatter(value) {
      return format(new Date(value), "HH:mm");
    },

    dateTimeFormatter(value) {
      return format(new Date(value), "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
    },

    onInput() {
      this.isAddButtonEnabled = true;
    },
  },
};
</script>

<style scoped>
.datetime-input {
  display: flex;
  gap: 0.5rem;
  margin-top: 10px;
}
.hide {
  display: none;
}
</style>
